import { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import DashboardPage from "./dashboard/DashboardPage";
import { LayoutSplashScreen } from "../../../_metronic";

export default function HomePage() {
	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				<Redirect exact from="/" to="/dashboard" />

				<Route path="/dashboard" component={DashboardPage} />

				<Redirect to="/error/error-v6" />
			</Switch>
		</Suspense>
	);
}
